var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"button is-dark is-outlined is-small",attrs:{"title":'Rescrape Scene'},on:{"click":function($event){return _vm.rescrapeScene()}}},[_c('b-icon',{attrs:{"pack":"mdi","icon":"web-refresh","size":"is-small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }